import React from "react";

import {
  Distance as DistanceClass,
  DistanceUnits,
  DistanceUnit,
} from "shared/utils";

interface DistanceProps {
  distance: number;
  toUnit?: DistanceUnit;
}

export const Distance: React.FC<DistanceProps> = ({
  distance,
  toUnit = DistanceUnits.m,
}) => {
  return (
    <>
      {new DistanceClass(distance, DistanceUnits.mm).convert(toUnit).toString()}
    </>
  );
};
